import {computed, reactive} from "vue";

const useNickname = () => {

  //この composition が扱うデータ
  const state = reactive({
    //エラー
    errors: {},

    //ニックネーム(キー: ID, 値: 名前文字列)
    nicknames: [],

    //ニックネーム ID (0: ユーザーネーム, -1 匿名)
    nicknameId: -2,
  });

  //選択されているニックネームを文字列で返す
  const nickname = computed(() => {
    //選択されている id から適合する name を検索する
    const name = state.nicknames.find(row => Number(row.id) === Number(state.nicknameId));

    //存在すれば name プロパティを返す
    return name ? name.name : 'クリックして名前を選択';
  });

  /**
   * POST 送信時に必須の HTTP ヘッダー設定を返す
   * @returns {{"X-Requested-With": string, "X-CSRF-TOKEN"}}
   * @private
   */
  const _getHeader = () => {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
    };
  };

  /**
   * 初期情報をサーバーより得て反映する
   * @return {Promise<void>}
   */
  const init = async () => {
    try {
      //サーバーより情報を得る
      const response = await fetch(siteUrl+'/place/init');

      //レスポンス異常発生
      if ( ! response.ok) {
        //もし 404 だったらログインしていない
        if (response.status === 404) {
          return;
        }

        //エラーメッセージを文字列に変換して例外を投げる
        throw new Error('エラーが発生しました。しばらくしてから再度お試しください。');
      }

      //パラメータを得る
      const parameter = await response.json();

      //情報を更新する
      state.nicknames = parameter.nicknames;
    }

    catch (error) {
      //恐らく通信途絶
      if (error instanceof TypeError) {
        state.errors = {messages: 'ネットワーク接続に失敗しました。'};
      }

      //恐らく意図的な中断
      else if (error instanceof DOMException) {
        state.errors = {messages: 'ネットワーク接続が中断されました。'};
      }

      //恐らくカスタムエラー(try 節中、意図的に throw している部分)
      else if (error instanceof Error) {
        state.errors = {messages: error.message};
      }

      //不明
      else {
        state.errors = {messages: 'エラーが発生しました。しばらくしてから再度お試しください。'};
      }
    }
  };

  /**
   * ニックネームを追加する
   * @param nickname
   * @returns {Promise<*|string[]|number>}
   */
  const appendNickname = async (nickname) => {
    //送信 body の作成
    const body = new FormData();
    body.append('nickname', nickname);

    //投稿をサーバーへ依頼する
    try {
      //通信開始
      const response = await fetch(siteUrl+'/place/set-nickname', {
        method: 'post',
        headers: _getHeader(),
        body: body
      });

      //レスポンス異常発生
      if ( ! response.ok) {
        //もし 404 だったらログインしていない
        if (response.status === 404) {
          throw new Error('ログインセッションが切れている可能性があります。恐れ入りますがページをリロードして再度ログインしてください。');
        }

        //エラーメッセージが返っているか判定
        const parameter = await response.json();

        //もしエラーメッセージが存在すれば返す
        if ('errors' in parameter && Array.isArray(parameter.errors)) {
          throw parameter.errors;
        }
        if ('errors' in parameter && typeof parameter.errors === 'object' && parameter.errors !== null) {
          throw Object.keys(parameter.errors).map(key => parameter.errors[key].join("\n"));
        }
        if ('messages' in parameter && Array.isArray(parameter.messages)) {
          throw parameter.messages;
        }

        //もし単発エラーがあれば返す
        if ('message' in parameter && typeof parameter.message === 'string') {
          throw [parameter.message];
        }

        //エラーメッセージを文字列に変換して例外を投げる
        throw new Error('エラーが発生しました。しばらくしてから再度お試しください。');
      }

      //パラメータを得る
      const parameter = await response.json();

      //情報を更新する
      state.nicknames = parameter.nicknames;

      //成功を返す
      return Number(parameter.id);
    }

      //サーバーとの通信中、なんらかのエラーが発生
    catch (error) {
      //恐らく通信途絶
      if (error instanceof TypeError) {
        state.errors = ['ネットワーク接続に失敗しました。'];
      }

      //恐らく意図的な中断
      else if (error instanceof DOMException) {
        state.errors = ['ネットワーク接続が中断されました。'];
      }

      //恐らくサーバーからのメッセージ
      else if (Array.isArray(error)) {
        state.errors = error;
      }

      //恐らくカスタムエラー
      else if (error instanceof Error) {
        state.errors = [error.message];
      }

      //不明
      else {
        state.errors = ['エラーが発生しました。しばらくしてから再度お試しください。'];
      }
    }
  };

  //ニックネームを選択する
  const useNickname = (nicknameId) => {
    state.nicknameId = nicknameId;
  };

  //提供
  return {
    state,
    nickname,
    init,
    appendNickname,
    useNickname
  };

};

//composition のエクスポート
export default useNickname;

//composition を注入するためのキー
export const USE_NICKNAME_KEY = Symbol('useNickname');
